// extracted by mini-css-extract-plugin
export default {"btn":"ButtonSort_btn__--TMS","btnTitle":"ButtonSort_btnTitle__a7E1p","btnIcon":"ButtonSort_btnIcon__VptPh","btnIcon_up":"ButtonSort_btnIcon_up__jKQMj"};